import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import ComparisonSection from "./components/ComparisonSection";
import WhySection from "./components/WhySection";
import ArticleCard from "./components/ArticleCard";
import ArticlesSection from "./components/ArticlesSection";
import CTASection from "./components/CTASection";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "OOPBuy Spreadsheet Hub",
  "url": "https://oopbuyspreadsheets.sbs/",
  "description": "Explore the most complete OOPBuy Spreadsheet database. Compare top-rated spreadsheets, discover updated lists, and find the best tools for dropshipping, e-commerce, and product sourcing in 2026.",
  "inLanguage": "en",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://oopbuyspreadsheets.sbs/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  return (
    <main>
      <SEO
        title="OOPBuy Spreadsheet List 2026 | Compare &amp; Find the Best OOPBuy Spreadsheets"
        description="Explore the most complete OOPBuy Spreadsheet database. Compare top-rated spreadsheets, discover updated lists, and find the best tools for dropshipping, e-commerce, and product sourcing in 2026."
        keywords="OOPBuy spreadsheet, oopbuy spreadsheet list, dropshipping spreadsheet, ecommerce product research, spreadsheet comparison 2026"
        canonicalPath="/"
        ogType="website"
        jsonLd={homeJsonLd}
        imageUrl="https://readdy.ai/api/search-image?query=Warm%20terracotta%20textile%20fabric%20spread%20flat%20lay%20with%20modern%20laptop%20in%20center%20displaying%20spreadsheet%20data%2C%20soft%20natural%20daylight%2C%20artisan%20workshop%20background%2C%20warm%20earthy%20tones%2C%20clean%20minimalist%20product%20photography%2C%20organic%20composition&width=1200&height=630&seq=seo-home-og&orientation=landscape"
      />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <ComparisonSection />
      <WhySection />
      <ArticleCard />
      <ArticlesSection />
      <CTASection />
      <Footer />
    </main>
  );
}